import _bundle from '../../../core/core--bundles';
import { _g } from '../../../core/core--base';

const { _library } = _g;
const { _utils } = _library;

export default function() {
    _bundle.add({
        name: 'Animation Enhancements',
        event: ['on:BundleReady'],
        fn() {
            _utils
                .poll(
                    function() {
                        return $('.menu-topics__item').length;
                    },
                    4000,
                    150
                )
                .then(function() {
                    // Sidbar Menu Built
                    $('.aside--fade-in').addClass('--toggle');
                })
                .catch(function() {});
        }
    });
}
